import React from "react";
import { FormRow, NumberField, NumberFieldProps } from "@shoptet/ui";

type NumberFieldWithUnitPropsT = {
  addon?: React.ReactNode;
  note?: string;
  unit: string;
  wrapperClassName?: string;
} & NumberFieldProps;

const NumberFieldWithUnit = React.forwardRef<HTMLInputElement, NumberFieldWithUnitPropsT>(
  ({ addon, error, label, labelHidden, note, required, tooltip, unit, wrapperClassName, ...inputProps }) => (
    <div className={wrapperClassName}>
      <FormRow label={label} labelHidden={labelHidden} required={required} tooltip={tooltip}>
        <div className="v2FormField__input">
          <span className="numberFieldWithUnit__control">
            <NumberField label={label} required={required} labelHidden {...inputProps} />
            {note && (
              <span
                style={{
                  position: "absolute",
                  right: "0",
                  left: "0",
                  top: "100%",
                  paddingTop: "6px",
                  color: "var(--app-text-muted)",
                }}
              >
                {note}
              </span>
            )}
            <span className="numberFieldWithUnit__unit">{unit}</span>
          </span>
          {addon && addon}
          {error && <span className="v2FormField__error">{error}</span>}
        </div>
      </FormRow>
    </div>
  )
);

NumberFieldWithUnit.displayName = "NumberFieldWithUnit";

export default NumberFieldWithUnit;
